import React, { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { X, Lock } from 'lucide-react';

// Choose courses a learner must complete before enrolling in this one
export const PrerequisiteCoursePicker = ({ courseId, value = [], onChange }) => {
  const { api } = useAuth();
  const [courses, setCourses] = useState([]);
  const [q, setQ] = useState('');

  useEffect(() => {
    api.get('/courses/admin/list?limit=200').then(r => setCourses(r.data?.courses || [])).catch(() => {});
  }, [api]);

  const selected = courses.filter(c => value.includes(c.id));
  const options = courses.filter(c => c.id !== courseId && !value.includes(c.id) && (!q || c.title.toLowerCase().includes(q.toLowerCase()))).slice(0, 8);

  return (
    <div className="space-y-2" data-testid="prereq-course-picker">
      <Label className="flex items-center gap-1.5"><Lock className="h-3.5 w-3.5" /> Required courses (enrolment is blocked until these are completed)</Label>
      <div className="flex flex-wrap gap-1.5">
        {selected.map(c => (
          <Badge key={c.id} variant="outline" className="bg-blue-50 gap-1" data-testid={`prereq-selected-${c.id}`}>
            {c.title}
            <button type="button" onClick={() => onChange(value.filter(id => id !== c.id))} aria-label={`Remove ${c.title}`}><X className="h-3 w-3" /></button>
          </Badge>
        ))}
        {!selected.length && <span className="text-xs text-slate-400">None — anyone can enrol.</span>}
      </div>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search courses to add as a requirement..." data-testid="prereq-search-input" />
      {q && (
        <div className="border border-slate-200 rounded-lg divide-y max-h-48 overflow-y-auto">
          {options.length ? options.map(c => (
            <button key={c.id} type="button" className="w-full text-left px-3 py-2 text-sm hover:bg-slate-50"
              onClick={() => { onChange([...value, c.id]); setQ(''); }} data-testid={`prereq-option-${c.id}`}>
              {c.title} <span className="text-xs text-slate-400">({c.status})</span>
            </button>
          )) : <p className="px-3 py-2 text-xs text-slate-400">No matching courses</p>}
        </div>
      )}
      <p className="text-[11px] text-slate-400">Admins can still enrol learners manually.</p>
    </div>
  );
};
